/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type { Signature as ForcProviderSignature } from "parog-web/components/forc/provider";
import eq from "ember-truth-helpers/helpers/eq";

const FamilyMembers = [
  "mother",
  "father",
  "sister",
  "brother",
  "grandmother",
  "grandfather",
  "aunt",
  "uncle",
  "female-cousin",
  "male-cousin"
];

const CancerTypes = ["lung", "ovarian", "colon", "bladder"];

interface Signature {
  Args: {
    form: ForcProviderSignature["Blocks"]["content"][0];
    AlignedFieldsRadioGroup?: unknown;
    patient?: unknown;
    Dropdown?: unknown;
  };
  Blocks: { default: [typeof FamilyMembers] };
}

export default class MedicalHistoryFormAntecedentsComponent extends Component<Signature> {
  get familyMembers(): string[] {
    return FamilyMembers;
  }

  get cancerTypes(): string[] {
    return CancerTypes;
  }

  eq = eq;
}
